import './App.css';

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LeadForm from './components/LeadForm';
import PrivacyPolicy from './components/PrivacyPolicy';

import logo from './assets/olx-logo.png'; // Import the image file

function Header() {
  return (
    <header className="app-header">
      <div className="app-logo">
        <img src={logo} alt="OLX" className="logo-image" />
      </div>
    </header>
  );
}

function Footer() {
  return (
    <footer className="app-footer">
      <div className="app-footer-text">
        OLX © 2025. Wszelkie prawa zastrzeżone. <a target="_blank" href="/polityka-prywatnosci">Polityka prywatności</a> <a target="_blank" href="https://pomoc.olx.pl/olxplhelp/s/article/Regulamin-akcji-promocyjnej-Otwórz-swój-biznes-na-OLX-odbierz-100-zwrotu-w-formie-punktów-OLX">Regulamin</a>
      </div>
    </footer>
  );
}

function App() {
  return (
    <div>
      <Header />
      <div className="banner-container">
        <div className="banner"></div>
      </div>
      <div className="app-container">
        <div className="welcome-container">
          <Router>
            <Routes>
              <Route path="/" element={<LeadForm />} />
              <Route path="/polityka-prywatnosci" element={<PrivacyPolicy />} />
            </Routes>
          </Router>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
